import React, {useEffect, useState} from 'react';
import {Button, Form, Modal} from 'react-bootstrap';
import InfoCircle from '@mui/icons-material/InfoRounded';
import {useData} from '../../../../context/ConfigDataContext';
import {NodeTypes} from '../../../../constants/nodeTypes';
import {circuitTemplate} from '../../../../constants/jsonTemplates';
import {Dropdown} from '../../../../../../shared/ui/Dropdown';

const CircuitForm = (props) => {
  const {circuitFormData, setCircuitFormData, saveCircuit, getDeviceNames} = useData();
  const [lastabwurf, setLastabwurf] = useState('');
  const [lastabwurfDevice, setLastabwurfDevice] = useState('');
  const {findNodeByName, selectedNode, treeData, isEditMode} = useData();

  const setSavedFormData = () => {
    const node = findNodeByName(treeData, selectedNode);
    if (node.type === NodeTypes.ADDNODE) {
      setCircuitFormData(circuitTemplate);
      return;
    }
    const formData = {...node.attributes};
    if (formData.actions && formData.actions.length > 0) {
      if (formData.actions[0].value === 1) setLastabwurf('nc');
      else if (formData.actions[0].value === 0) setLastabwurf('no');
      setLastabwurfDevice(formData.actions[0].deviceName);
    }
    setCircuitFormData(node.attributes);
    return node;
  };

  const handleMeasurementChange = (e) => {
    setCircuitFormData({
      ...circuitFormData,
      measurement: {...circuitFormData.measurement, [e.target.name]: e.target.value},
    });
  };

  const onFuseChange = (e) => {
    setCircuitFormData({
      ...circuitFormData,
      controlSettings: {
        ...circuitFormData.controlSettings,
        lowerLimit: e.target.value * 0.8,
        upperLimit: Number(e.target.value),
      },
    });
  };

  const onNameChange = (e) => {
    setCircuitFormData({...circuitFormData, circuitName: e.target.value});
  };

  useEffect(() => {
    setSavedFormData();
  }, [props.show]);

  useEffect(() => {
    if (lastabwurf) {
      setCircuitFormData({
        ...circuitFormData,
        actions: [{deviceName: lastabwurfDevice, value: lastabwurf === 'nc' ? 1 : 0, decission: -100}],
      });
    } else {
      setCircuitFormData({...circuitFormData, actions: []});
    }
  }, [lastabwurf, lastabwurfDevice]);

  const invalidInput = () => {
    if (circuitFormData.measurement.type === 'device' && circuitFormData.measurement.deviceName === '') return true;
    if (!circuitFormData.controlSettings.upperLimit) return true;
    return false;
  };

  return (
    <>
      <Modal.Header>
        <div className="d-flex align-items-center gap-2">
          <h4 className="mb-0">Circuit</h4>
          <a href="https://lehmannch.atlassian.net/wiki/spaces/SCCKH/pages/771424259/Web+App+SCC-Cloud#Circuit"
             target="_blank" rel="noopener noreferrer">
            <InfoCircle size={20}/>
          </a>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Control type="text" name="circuitName" value={circuitFormData.circuitName} onChange={onNameChange}/>
          </Form.Group>
          <Form.Group>
            <Form.Label>Measurement</Form.Label>
            <Dropdown
              name="type"
              options={[
                {value: 'sum', label: 'Sum'},
                {value: 'device', label: 'Device'},
              ]}
              value={circuitFormData.measurement.type}
              onChange={handleMeasurementChange}
              block
            />
          </Form.Group>
          {circuitFormData.measurement.type === 'device' && (
            <Form.Group>
              <Form.Label>Measurement Device</Form.Label>
              <Dropdown
                name="deviceName"
                options={getDeviceNames()
                  .filter(({deviceType}) => deviceType !== 'RpiGPIO')
                  .map(({deviceName}) => ({value: deviceName, label: deviceName}))}
                value={circuitFormData.measurement.deviceName}
                onChange={handleMeasurementChange}
                placeholder="Select..."
                block
              />
            </Form.Group>
          )}
          <Form.Group>
            <Form.Label>Fuse Protection of Measurement Point [A]</Form.Label>
            <Form.Control type="number" name="upperLimit" value={circuitFormData.controlSettings.upperLimit}
                          onChange={onFuseChange}/>
          </Form.Group>
          <Form.Group>
            <Form.Label>Load Shedding</Form.Label>
            <Form.Check type="radio" label="No Load Shedding" value="kein_lastbwurf" checked={lastabwurf === ''}
                        onChange={() => setLastabwurf('')} name="radioOptions" id="keinLastbwurf"/>
            <Form.Check type="radio" label="Load Shedding: NC, contact closed in normal operation" value="nc"
                        checked={lastabwurf === 'nc'} onChange={() => setLastabwurf('nc')} name="radioOptions"
                        id="ncKontakt"/>
            <Form.Check type="radio" label="Load Shedding: NO, contact open in normal operation" value="no"
                        checked={lastabwurf === 'no'} onChange={() => setLastabwurf('no')} name="radioOptions"
                        id="noKontakt"/>
            {lastabwurf && (
              <Dropdown
                options={getDeviceNames()
                  .filter(({deviceType, deviceSubType}) => deviceType === 'RpiGPIO' || deviceSubType === 'SiemensPAC2200')
                  .map(({deviceName}) => ({value: deviceName, label: deviceName}))}
                value={lastabwurfDevice}
                onChange={(val) => setLastabwurfDevice(val)}
                placeholder="Select..."
                block
              />
            )}
            <small>If this is a subordinate circuit, the load shedding will be inherited from the parent
              circuit.</small>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={saveCircuit} disabled={invalidInput()}>Save</Button>
      </Modal.Footer>
    </>
  );
};

export default CircuitForm;

